import { DataTableColumn } from './types';

export const getSize = (
  size: number | string | undefined,
  columns: DataTableColumn[]
) => {
  if (typeof size === 'number') return `${size}px`;
  if (size === 'large') return `${(1 / columns.length) * 100 + 5}%`;
  return size;
};

export const getAlign = (align: string | undefined) => {
  if (align === 'center') return 'tw-justify-center';
  if (align === 'right') return 'tw-justify-end';
  return 'tw-justify-start';
};
